import {createSelector} from "reselect";
import {isLoadingDealers} from "./dealers";
import {isLoadingSelectedDealer} from "./customerDealer";

export const isLoading = createSelector(isLoadingDealers, isLoadingSelectedDealer, (...args) => args.some(Boolean));
